export default __webpack_public_path__ + "static/media/clock.5e280d10.svg";